module.exports = __webpack_public_path__ + "static/media/xmg_mango_pineapple.e73262de.png";